export const dialColor = '#F75B3B';

export const dialLayerColor = dialColor;
